import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { generateUUID } from '../utils/useWebSocket';
import Chat from './Chat';

const Dashboard: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [uuid, setUuid] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    
    const newUuid = generateUUID();
    setUuid(newUuid);
    // Update URL with new UUID
    navigate(`/app/chat/${newUuid}`, { replace: true });
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {uuid !== '' ? <Chat /> : null}
    </>
  );
};

export default Dashboard;
